<template>
	<div class="fixed inset-0 z-30 overflow-y-auto bg-black/40" @click="emit('close')">
		<div class="flex min-h-full items-center justify-center p-4">
			<div class="relative w-full max-w-md p-5 bg-white rounded-lg" @click.stop>
				<button
					type="button"
					class="absolute inline-flex items-center justify-center w-10 h-10 rounded-full right-3 top-3 text-neutral-500 hover:bg-black/5"
					:aria-label="t('close')"
					@click="emit('close')"
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-6">
						<path
							fill="currentColor"
							fill-rule="nonzero"
							d="M19.284 18.216a.76.76 0 0 1 0 1.068.769.769 0 0 1-1.068 0L12 13.06l-6.216 6.225a.769.769 0 0 1-1.068 0 .76.76 0 0 1 0-1.068L10.94 12 4.716 5.784a.76.76 0 0 1 1.068-1.068L12 10.94l6.216-6.225a.76.76 0 0 1 1.068 1.068L13.06 12l6.225 6.216Z"
						/>
					</svg>
				</button>

				<h3 class="font-serif text-2xl pr-10">{{ t('i_have_a_gift_voucher') }}</h3>

				<div
					ref="content"
					class="my-6 text-neutral-600 [&_p]:my-4 [&_a]:text-primary [&_a]:underline"
					v-html="explanation"
				></div>

				<button type="button" class="btn-primary w-full" @click="emit('close')">
					{{ t('close') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  explanation: string;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const content = ref<HTMLElement>();

// Managed content may contain a link (e.g. the saldochecker); open those in a new tab.
onMounted(() => {
  content.value?.querySelectorAll('a').forEach(anchor => {
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  });
});
</script>
